import { computed, ref, useContext } from "@nuxtjs/composition-api";
import { useMultiLoginStore } from "../stores/multilogin";
import { useUser } from "@wemade-vsf/customer";
import { useEvent, useListen } from "@wemade-vsf/composables";
import { Logger } from "@wemade-vsf/core";
function useMultilogin() {
  const { app } = useContext();
  const multiLoginStore = useMultiLoginStore();
  const { user } = useUser();
  const loading = ref(false);
  useListen("quote-cart:view", () => {
    if (multiLoginStore.isSalesPerson) {
      addSalesRepToQuoteCart();
    }
  });
  useListen("cart:view", () => {
    if (multiLoginStore.isSalesPerson) {
      addSalesRepToCart();
    }
  });
  useListen("user:logout", () => {
    multiLoginStore.reset();
  });
  async function loadSalesRelations() {
    var _a;
    const salesToken = app.$vsf.$magento.config.state.getSalesToken();
    if (salesToken) {
      const { data } = await app.$vsf.$magento.api.mlGetSalesRelations();
      if ((_a = data == null ? void 0 : data.customer) == null ? void 0 : _a.sales_relations) {
        multiLoginStore.$patch((state) => {
          state.isSalesPerson = true;
          state.salesRepId = data.customer.sales_rep_id;
          state.salesRelations = data.customer.sales_relations;
        });
      }
    }
  }
  async function switchCompany(companyId) {
    var _a;
    Logger.debug("useMultilogin/switchCompany", companyId);
    loading.value = true;
    try {
      const { data } = await app.$vsf.$magento.api.mlSwitchCompany(companyId);
      if ((_a = data == null ? void 0 : data.wmSwitchToCompany) == null ? void 0 : _a.token) {
        app.$vsf.$magento.config.state.setCustomerToken(data.wmSwitchToCompany.token);
        useEvent("multilogin:afterSwitch");
      }
    } catch (err) {
      Logger.error("useMultilogin/switchCompany", err);
    } finally {
      loading.value = false;
    }
  }
  async function addSalesRepToCart() {
    try {
      await app.$vsf.$magento.api.mlAddSalesRepToCart(multiLoginStore.salesRepId);
    } catch (err) {
      Logger.error("useMultilogin/addSalesRepToCart", err);
    }
  }
  async function addSalesRepToQuoteCart() {
    try {
      await app.$vsf.$magento.api.mlAddSalesRepToQuoteCart(multiLoginStore.salesRepId);
    } catch (err) {
      Logger.error("useMultilogin/addSalesRepToQuoteCart", err);
    }
  }
  const currentSalesRelation = computed(() => {
    var _a, _b;
    return (_b = (_a = multiLoginStore.salesRelations) == null ? void 0 : _a.find((relation) => {
      var _a2;
      return relation.company_id === Number((_a2 = user.value) == null ? void 0 : _a2.company_id);
    })) != null ? _b : null;
  });
  return {
    loading,
    loadSalesRelations,
    addSalesRepToCart,
    addSalesRepToQuoteCart,
    switchCompany,
    isSalesPerson: computed(() => multiLoginStore.isSalesPerson),
    salesRepId: computed(() => multiLoginStore.salesRepId),
    salesRelations: computed(() => multiLoginStore.salesRelations),
    currentSalesRelation
  };
}
export {
  useMultilogin
};
